exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mapboxgl-ctrl.mapboxgl-ctrl-attrib.mapboxgl-compact {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  white-space: nowrap;\n}", ""]);

// exports
